<template lang="pug">
article-list-page-template.px-lg-15(
  :title="pageTitle",
  :loading="loading",
  :page="page",
  :pagesLength="pagesLength",
  :pages-total-visible="pagesTotalVisible",
  no-data-text="Nenhuma lição de casa disponível."
)
  template(#top)
    .mb-2
      v-icon.mt-n1(left, small) fas fa-filter
      span.text-h6.text--secondary Filtro
    grid-container(
      cols="auto",
      cols-sm="repeat(2, calc((100% - 20px) / 2))",
      cols-lg="repeat(4, calc((100% - 60px) / 4))"
    )
      v-select(
        v-model="selectedClass",
        :items="classes",
        label="Classe",
        no-data-text="",
        outlined,
        dense,
        hide-details
      )
      v-select(
        v-model="selectedYear",
        :items="years",
        label="Ano",
        no-data-text="",
        outlined,
        dense,
        hide-details
      )
      v-select(
        v-model="selectedMonth",
        :items="months",
        label="Mês",
        no-data-text="",
        outlined,
        dense,
        hide-details
      )
      v-text-field(
        v-model="search",
        label="Pesquisar",
        outlined,
        dense,
        hide-details
      )
    v-divider.mt-4.grey

  template(#items)
    homework-card.mx-auto(
      v-for="({ title, text, to, date_start, date_end, discipline, expired }, i) in items",
      :key="i",
      :title="title",
      :text="text",
      :to="to",
      :date-start="date_start",
      :date-end="date_end",
      :discipline="discipline",
      :expired="expired"
    )
  template(#side)
    communications-widget
</template>

<script>
import ArticleListPageTemplate from "@/components/templates/ArticleListPage.vue";
import HomeworkCard from "@/components/cards/Homework";
import CommunicationsWidget from "@/components/widgets/Communications";
import { formatToURL } from "@/components/utils.js";

const _config = {
  mod: "homeworks",
  title: "Lição de Casa",
  path: "/aluno/licao-de-casa",
  itemsPerPage: 12,
};

export default {
  data: () => ({
    pageTitle: _config.title,
    loading: true,
    totalItems: 0,
  }),
  computed: {
    pagesTotalVisible() {
      return this.$vuetify.breakpoint.smAndDown ? 3 : 6;
    },
    page() {
      const p = this.$route.query.p;
      return p ? parseInt(p) : 1;
    },
    pagesLength() {
      return Math.ceil(this.totalItems / _config.itemsPerPage);
    },
    items() {
      return this.$rest(_config.mod).list.map(
        ({ id, title, text, date_start, date_end, discipline, expired }) => ({
          title,
          text,
          to: `${_config.path}/${formatToURL(title)}-${id}`,
          date_start,
          date_end,
          discipline,
          expired: expired == 1 ? true : false,
        })
      );
    },
    metaData() {
      return this.$rest("homeworksMetadata").item;
    },
    classes() {
      const classes = this.metaData.classes
        ? this.metaData.classes.map(({ id, title }) => ({
            text: title,
            value: id,
          }))
        : [];

      classes.unshift({ text: "Todas", value: null });

      return classes;
    },
    months() {
      const months = this.metaData.months
        ? Object.entries(this.metaData.months).map(([value, text]) => ({
            text,
            value,
          }))
        : [];

      months.unshift({ text: "Todas", value: null });

      return months;
    },
    years() {
      const years = this.metaData.years || [];

      years.unshift({ text: "Todas", value: null });

      return years;
    },
    search: {
      set(v) {
        const query = { ...this.$route.query };
        if (v) query.s = v;
        else delete query.s;

        delete query.p;

        this.$router.push({ query });
      },
      get() {
        return this.$route.query.s || null;
      },
    },
    selectedClass: {
      set(v) {
        const query = { ...this.$route.query };
        if (v) query.c = v;
        else delete query.c;

        delete query.p;

        this.$router.push({ query });
      },
      get() {
        return this.$route.query.c || null;
      },
    },
    selectedYear: {
      set(v) {
        const query = { ...this.$route.query };
        if (v) query.y = v;
        else delete query.y;

        delete query.p;

        this.$router.push({ query });
      },
      get() {
        return this.$route.query.y || null;
      },
    },
    selectedMonth: {
      set(v) {
        const query = { ...this.$route.query };
        if (v) query.m = v;
        else delete query.m;

        delete query.p;

        this.$router.push({ query });
      },
      get() {
        return this.$route.query.m || null;
      },
    },
  },
  methods: {
    getItems() {
      this.loading = true;

      const params = {
        returnTotalItems: 1,
        itemsPerPage: _config.itemsPerPage,
      };

      if (this.page) params.page = this.page;

      if (this.selectedClass) params.class = this.selectedClass;
      if (this.selectedYear) params.year = this.selectedYear;
      if (this.selectedMonth) params.month = this.selectedMonth;
      if (this.search) params.search = this.search;

      this.$rest(_config.mod).get({
        params,
        keepCache: true,
        save: (state, { totalItems, list }) => {
          this.totalItems = totalItems;
          state.list = list;
          this.loading = false;
        },
      });
    },
  },
  watch: {
    $route() {
      this.getItems();
    },
  },
  created() {
    this.getItems();
    this.$rest("homeworksMetadata").get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    ArticleListPageTemplate,
    HomeworkCard,
    CommunicationsWidget,
  },
};
</script>
